//TODO: Deprecate this file into themeprovider

export const EFFICIENCY_FONT_SIZE = 24;
export const NAME_FONT_SIZE = 18;
export const OVERCLOCK_STROKE_SIZE = 3;
